import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'app-sales-phone-enrollment-manual-init-enrollment-knox',
  templateUrl: './sales-phone-enrollment-manual-init-enrollment-knox.component.html',
  styles: [
  ]
})
export class SalesPhoneEnrollmentManualInitEnrollmentKnoxComponent {
  routesBreadcrumbs = ['VENTAS', 'Autogestión', 'Enrolamiento de teléfono']
  @Input() phoneEnrollmentData!: any;
  @Output() step = new EventEmitter();

  constructor() {
  }

  goToEnrollmentLink(url: string) {
    window.open(url,'_blank');
    setTimeout(()=>{
      this.step.emit('questions-process');

    },10000)
  }

  onReturnQuestionsProcess(){
    this.step.emit('questions-process');
  }

}
